import apiService from '../../../services/api'
import { openExternalPaymentLink } from '../utils/openExternalPaymentLink'

/**
 * UZS (Узбекистан) API
 * Оплата через P2P перевод на карту
 */

export const fetchUzsConfig = async (method = 'uzs1') => {
  try {
    const response = await apiService.makeRequest(`/api/${method}/`)

    if (response.uzs) {
      return { ...response.uzs, promo: response.promo || null }
    }

    throw new Error('Invalid response format: uzs config not found')
  } catch (error) {
    console.error('Error fetching UZS config:', error)
    throw error
  }
}

export const fetchUzsPackages = async (method = 'uzs1') => {
  try {
    const response = await apiService.makeRequest('/api/topup/')

    if (response.topup && Array.isArray(response.topup)) {
      return response.topup.filter((pkg) => pkg[method] != null)
    }

    throw new Error('Invalid response format: topup array not found')
  } catch (error) {
    console.error('Error fetching UZS packages:', error)
    throw error
  }
}

// Режим работы UZS оплаты.
// Переключите на DETAILS, чтобы вернуться к старой схеме с реквизитами.
export const UZS_PAYMENT_FLOW = {
  LINK: 'link',
  DETAILS: 'details'
}

// export const UZS_PAYMENT_FLOW_MODE = UZS_PAYMENT_FLOW.DETAILS
export const UZS_PAYMENT_FLOW_MODE = UZS_PAYMENT_FLOW.LINK

const normalizeUzsCreateError = (response) => {
  if (!response?.error) return null

  if (response.error === 'error sum') return 'INVALID_AMOUNT'
  if (response.error === 'error backend') return 'BACKEND_ERROR'
  if (response.error === 'error limit') return 'LIMIT_ORDER'

  return response.error
}

const normalizeUzsPaymentResponse = (response) => {
  if (UZS_PAYMENT_FLOW_MODE === UZS_PAYMENT_FLOW.DETAILS) {
    if (response.order_id && response.number_card && response.fio) {
      return { mode: UZS_PAYMENT_FLOW.DETAILS, data: response }
    }
  }

  if (response.link) {
    return { mode: UZS_PAYMENT_FLOW.LINK, link: response.link }
  }

  if (response.order_id && response.number_card && response.fio) {
    return { mode: UZS_PAYMENT_FLOW.DETAILS, data: response }
  }

  throw new Error('Invalid response format: payment data not found')
}

export const createPaymentByUzs = async (uzs, method = 'uzs1') => {
  try {
    const response = await apiService.makeRequest(`/api/${method}/`, {
      method: 'POST',
      body: JSON.stringify({ uzs })
    })

    const normalizedError = normalizeUzsCreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (['uzs3', 'uzs4', 'uzs5', 'uzs6', 'uzs7'].includes(method) && !response.link) throw new Error('Invalid response format: payment link not found')
    return normalizeUzsPaymentResponse(response)
  } catch (error) {
    const normalizedError = normalizeUzsCreateError({ error: error.message })
    if (normalizedError && normalizedError !== error.message) throw new Error(normalizedError)
    console.error('Error creating UZS payment by uzs:', error)
    throw error
  }
}

export const createPaymentByCrystals = async (crystals, method = 'uzs1') => {
  try {
    const response = await apiService.makeRequest(`/api/${method}/`, {
      method: 'POST',
      body: JSON.stringify({ crystal: crystals })
    })

    const normalizedError = normalizeUzsCreateError(response)
    if (normalizedError) throw new Error(normalizedError)

    if (['uzs3', 'uzs4', 'uzs5', 'uzs6', 'uzs7'].includes(method) && !response.link) throw new Error('Invalid response format: payment link not found')
    return normalizeUzsPaymentResponse(response)
  } catch (error) {
    const normalizedError = normalizeUzsCreateError({ error: error.message })
    if (normalizedError && normalizedError !== error.message) throw new Error(normalizedError)
    console.error('Error creating UZS payment by crystals:', error)
    throw error
  }
}

export const openUzsPayment = (paymentLink, onRedirect, paymentWindow = null) => {
  openExternalPaymentLink(paymentLink, onRedirect, 'UZS', paymentWindow)
}

export default {
  fetchUzsConfig,
  fetchUzsPackages,
  createPaymentByUzs,
  createPaymentByCrystals,
  openUzsPayment
}
